import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import { getImageField } from '../../../../utils/getImageFields';
import Picture from '../../../@shared/picture';
import { TEditorialImageProps } from '../../../@shared/picture/types/editorialImage.types';
import VideoPlayer from '../../../@shared/videoPlayer';
import { getThumbnailProps } from '../../../../utils/youtubeUtils';
import { TRelatedNewsMedia } from '../../types/relatedNews.types';

const Media: FC<TRelatedNewsMedia> = (props) => {
  const { desktopImage, mobileImage, defaultImage, useVideo, videoUrl, isDesktop } = props;
  if (useVideo && videoUrl) {
    const { thumbnailImgSrc } = getThumbnailProps(videoUrl);
    const desktopImageOrThumbnail = getImageField(desktopImage, thumbnailImgSrc || '', useVideo);
    const mobileImageOrThumbnail = getImageField(mobileImage, thumbnailImgSrc || '', useVideo);
    return (
      <div className="related-news-card__media-wrapper related-news-card__media-wrapper--thumbnail">
        <VideoPlayer
          link={videoUrl}
          autoPlay={true}
          showThumbnail={true}
          editorialImageProps={{
            desktopImage: desktopImageOrThumbnail,
            mobileImage: mobileImageOrThumbnail,
            isEditable: true,
            alt: (isDesktop ? desktopImageOrThumbnail?.value?.alt : mobileImageOrThumbnail?.value?.alt) as string,
          }}
          desktopPlayIconSize={iconSize.lg}
          mobilePlayIconSize={iconSize.lg}
        />
      </div>
    );
  }

  const shouldShowDefaultImage = !desktopImage?.value?.src && !mobileImage?.value?.src;
  const editorialProps: TEditorialImageProps = {
    mobileImage: mobileImage,
    desktopImage: desktopImage,
    mobileTransformation: 'Size1000',
    desktopTransformation: 'Size1000',
    cssClassPictureEl: 'related-news-card__image',
    alt: (isDesktop ? desktopImage?.value?.alt : mobileImage?.value?.alt) as string,
  };
  if (shouldShowDefaultImage && defaultImage) {
    editorialProps['mobileImage'] = undefined;
    editorialProps['desktopImage'] = defaultImage;
  }
  return (
    <div className="related-news-card__media-wrapper">
      <Picture editorialImageProps={editorialProps} />
    </div>
  );
};

export default Media;
